import { render, staticRenderFns } from "./dashboard-spinner.vue?vue&type=template&id=9031583c&scoped=true&"
import script from "./dashboard-spinner.vue?vue&type=script&lang=js&"
export * from "./dashboard-spinner.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-spinner.vue?vue&type=style&index=0&id=9031583c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9031583c",
  null
  
)

export default component.exports